const deriveDefaultPayrollPeriod = () => {
  const date = new Date()
  const d = date.getDate() // 1–31
  const m = date.getMonth() // 0–11
  const y = date.getFullYear()

  // payroll period label is the month that contains the 20th:
  const periodMonthIndex = d < 21 ? m : (m + 1) % 12
  const periodYear = m === 11 && d >= 21 ? y + 1 : y

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  return `${monthNames[periodMonthIndex]}${periodYear}`
}

export default deriveDefaultPayrollPeriod
